import { Api } from '@/services/Api'

export default {
  configPoa(data) {
    return Api().post('/api/v1.0/poa_config', data)
  },
  getConfigDetails(plantId) {
    return Api().get(`/api/v1.0/poa_config/details/${plantId}`)
  },
  getWsDetails(plantId, blockId) {
    return Api().get(`/api/v1.0/poa_config/wsDetails/${plantId}/${blockId}`)
  },
  getWeatherDetails(plantId) {
    return Api().get(`/api/v1.0/poa_config/wsDetails/${plantId}`)
  },
  getWsBlock(plantId) {
    return Api().get(`/api/v1.0/poa_config/blockList/${plantId}`)
  }
}
